import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'b', 'i', 'blockquote', 'span'];
const ALLOWED_ATTR = ['class', 'style'];

export function sanitizeHtml(html: string | null | undefined): string {
    if (!html) return '';

    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
    });
}
